import React from 'react'
import "./Slider.css";

import nadialandsale from "../images/banner-homepage.png";
import listyourproperty from "../images/LIST YOUR PROPERTY.jpg";

function Slider() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
        <div className='landsale'>
      <img src={nadialandsale} className="d-block w-100" alt="nadialandsale"/>
      </div>
    </div>
    <div className="carousel-item">
         <div className='landsale'>
      <img src={listyourproperty} className="d-block w-100" alt="listyourproperty"/>
      </div>
    </div>
    <div className="carousel-item">
         <div className='landsale'>
      <img src={nadialandsale} className="d-block w-100" alt="nadialandbuy"/>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider